<template>
  <div class="category">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="商品分类"
      fixed
    />
    
    <!-- 给整体内容添加一个容器，处理固定导航栏的遮挡 -->
    <div class="content-container">
      <!-- 左侧导航栏 -->
      <div class="nav-sidebar">
        <div class="sidebar-item" 
             v-for="(item, index) in categories" 
             :key="index"
             :class="{ active: currentIndex === index }"
             @click="switchCategory(index)">
          {{ item.name }}
        </div>
      </div>
      
      <!-- 右侧内容区 -->
      <div class="content">
        <div class="category-title">{{ categories[currentIndex].name }}</div>
        <div class="category-grid">
          <div class="grid-item" v-for="(subItem, subIndex) in categories[currentIndex].subCategories" :key="subIndex">
            <img :src="subItem.image" :alt="subItem.name">
            <span>{{ subItem.name }}</span>
          </div>
        </div>
      </div>
    </div>
	<div style="padding: 40px 0;"><a href="https://beian.miit.gov.cn/">琼ICP备2025057209号-1</a></div>
  </div>
</template>

<script>
export default {
  name: 'CategoryPage',
  data() {
    return {
      currentIndex: 0,
      categories: [
        {
          name: '手机',
          subCategories: [
            { name: '苹果手机', image: require('@/assets/phone1.png') },
            { name: '华为手机', image: require('@/assets/phone2.png') },
            { name: '小米手机', image: require('@/assets/phone1.png') },
            { name: 'OPPO手机', image: require('@/assets/phone2.png') },
            { name: 'vivo手机', image: require('@/assets/phone1.png') }
          ]
        },
        {
          name: '电脑',
          subCategories: [
            { name: '游戏本', image: require('@/assets/computer1.png') },
            { name: '商务本', image: require('@/assets/computer2.png') },
            { name: '台式机', image: require('@/assets/computer1.png') }
          ]
        },
        {
          name: '平板',
          subCategories: [
            { name: 'iPad', image: require('@/assets/computer2.png') },
            { name: '安卓平板', image: require('@/assets/computer1.png') }
          ]
        },
        {
          name: '配件',
          subCategories: [
            { name: '耳机', image: require('@/assets/phone1.png') },
            { name: '充电器', image: require('@/assets/phone2.png') },
            { name: '手机壳', image: require('@/assets/computer1.png') },
            { name: '贴膜', image: require('@/assets/computer2.png') }
          ]
        },
        {
          name: '智能设备',
          subCategories: [
            { name: '智能手表', image: require('@/assets/phone1.png') },
            { name: '智能手环', image: require('@/assets/phone2.png') }
          ]
        }
      ]
    }
  },
  methods: {
    switchCategory(index) {
      this.currentIndex = index
    }
  }
}
</script>

<style scoped>
.category {
  min-height: 100vh;
  background: #fff;
}

.content-container {
  padding-top: 18px; /* 为固定的顶部导航栏留出空间 */
  display: flex;
  height: calc(100vh - 18px); /* 减去顶部导航栏的高度 */
}

.nav-sidebar {
  width: 85px;
  height: 100%;
  background: #f7f8fa;
  overflow-y: auto;
}

.sidebar-item {
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 14px;
  color: #323233;
  cursor: pointer;
}

.sidebar-item.active {
  background: #fff;
  color: #1989fa;
  font-weight: 500;
}

.content {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
}

.category-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  padding-left: 5px;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.grid-item img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 8px;
}

.grid-item span {
  font-size: 13px;
  color: #323233;
}

/* 导航栏样式 */
:deep(.van-nav-bar) {
  background-color: #fff;
}

:deep(.van-nav-bar__title) {
  color: #323233;
  font-size: 16px;
}
</style>  